import { render } from "./SearchComponents.vue?vue&type=template&id=b006073a&scoped=true"
import script from "./SearchComponents.vue?vue&type=script&lang=js"
export * from "./SearchComponents.vue?vue&type=script&lang=js"

import "./SearchComponents.vue?vue&type=style&index=0&id=b006073a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b006073a"]])

export default __exports__